import { createQueryKeys } from '@lukemorales/query-key-factory'

const modules = createQueryKeys('modules', {
  list: (courseId: number) => ({ queryKey: [courseId] }),
  overview: (moduleId: number) => ({ queryKey: [moduleId] }),
  detail: (moduleId: number) => ({ queryKey: [moduleId] })
})

export default modules
